import InputText from "./InputText.jsx";

export default InputText